/* ============================================================================
   CAMPANII CADOU (Gift-With-Purchase) — ADD TO CART
   ----------------------------------------------------------------------------
   Slide-urile de campanie sunt randate de dc_bundle_campaigns.liquid ca
   .bundle-wrapper--campaign in acelasi .bundle-carousel ca bundle-urile.

   VIZIBILITATEA PE VARIANTA nu mai e tratata aici — o conduce updateVisibleBundles()
   din dc_bundle_products_metafield.js (selectorul acopera si --campaign), la fel ca
   VERIFICAREA DE STOC (checkBundleStock, acelasi fisier). Aici ramane DOAR add-to-cart,
   cu properties PROPRII _campaign_* (paralel cu _bundle_*, ca sa nu se confunde in
   comanda un "bundle cumparat" cu un "produs cadou primit prin campanie" si sa nu
   colizioneze cu logica de merge/reconciliere combo care cheie pe _bundle_ / _combo_group).
============================================================================ */

document.addEventListener("click", async function (event) {
  const button = event.target.closest(".campaign-bundle-button");
  if (!button) return;

  event.preventDefault();

  const wrapper = button.closest(".bundle-wrapper--campaign");
  if (!wrapper) return;

  const form = wrapper.querySelector(".bundle-add-all-form");
  if (!form) return;

  const formData = new FormData(form);
  const items = [];

  for (let [key, value] of formData.entries()) {
    const match = key.match(/items\[(\d+)\]\[(id|quantity)\]/);
    if (!match) continue;
    const index = parseInt(match[1], 10);
    const field = match[2];
    if (!items[index]) items[index] = {};
    items[index][field] = value;
  }

  if (!items.length || !items[0]?.id) return;

  // TOATE liniile (ancora + cadouri) se adauga PLAIN, fara properties (rescriere
  // lp-n6g.24): gratuitatea cadoului e facuta de un DISCOUNT AUTOMAT NATIV din
  // Shopify Admin, nu de noi. Fara props => cadourile aceleiasi variante se pliaza
  // NATIV prin add.js/merge intr-o singura linie (nu mai raman 2 linii „protejate"
  // ne-mergeuibile ca inainte). campaignInstance ramane nefolosit intentionat.
  const cleanItems = items.filter(Boolean);

  const originalText = button.textContent.trim();
  button.textContent = "Produsele se adaugă în coș...";
  button.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cleanItems }),
    });

    if (!response.ok) {
      button.textContent = "Eroare";
      button.disabled = false;
      return;
    }

    button.textContent = originalText;
    button.disabled = false;

    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
    } else {
      window.location.href = "/cart";
    }
  } catch (err) {
    button.textContent = "Eroare";
    button.disabled = false;
  }
});
